(() => {
    'use strict';

    const VIDEO_SELECTOR =
        'video';

    const DEFERRED_MEDIA_SELECTOR =
        'deferred-media';

    const DEFERRED_BUTTON_SELECTOR =
        '[data-deferred-media-button]';

    /**
     * Fuerza configuración compatible con autoplay.
     */
    function prepareVideo(video) {
        if (!(video instanceof HTMLVideoElement)) {
            return;
        }

        video.muted = true;
        video.defaultMuted = true;
        video.autoplay = true;
        video.loop = true;
        video.playsInline = true;

        video.setAttribute('muted', '');
        video.setAttribute('autoplay', '');
        video.setAttribute('loop', '');
        video.setAttribute('playsinline', '');

        const playPromise = video.play();

        if (
            playPromise &&
            typeof playPromise.catch === 'function'
        ) {
            playPromise.catch((error) => {
                /*
                 * No lo consideramos error fatal.
                 * Algunos navegadores todavía pueden bloquear
                 * autoplay bajo determinadas condiciones.
                 */
                console.debug(
                    '[ProductVideoAutoplay] autoplay bloqueado:',
                    error
                );
            });
        }
    }

    /**
     * Activa todos los videos ya presentes.
     */
    function playVideos(root = document) {
        if (
            root instanceof HTMLVideoElement
        ) {
            prepareVideo(root);
            return;
        }

        root
            .querySelectorAll?.(VIDEO_SELECTOR)
            .forEach(prepareVideo);
    }

    /**
     * PDP:
     * fuerza a deferred-media a insertar su contenido.
     */
    function loadDeferredMedia(root = document) {
        const deferredMediaElements = [];

        if (
            root instanceof Element &&
            root.matches(DEFERRED_MEDIA_SELECTOR)
        ) {
            deferredMediaElements.push(root);
        }

        root
            .querySelectorAll?.(
                DEFERRED_MEDIA_SELECTOR
            )
            .forEach((element) => {
                deferredMediaElements.push(element);
            });

        deferredMediaElements.forEach(
            (deferredMedia) => {
                /*
                 * Ya fue cargado.
                 */
                if (
                    deferredMedia.hasAttribute(
                        'loaded'
                    )
                ) {
                    playVideos(deferredMedia);
                    return;
                }

                /*
                 * Utilizamos la API real del custom element
                 * cuando está disponible.
                 */
                if (
                    typeof deferredMedia.loadContent ===
                    'function'
                ) {
                    deferredMedia.loadContent(false);

                    requestAnimationFrame(() => {
                        playVideos(deferredMedia);
                    });

                    return;
                }

                /*
                 * Fallback por si el custom element todavía
                 * no se actualizó.
                 */
                const button =
                    deferredMedia.querySelector(
                        DEFERRED_BUTTON_SELECTOR
                    );

                button?.click();
            }
        );
    }

    /**
     * Inicializa medias actuales.
     */
    function initialize(root = document) {
        loadDeferredMedia(root);
        playVideos(root);
    }

    /**
     * Primera carga.
     */
    if (
        document.readyState === 'loading'
    ) {
        document.addEventListener(
            'DOMContentLoaded',
            () => initialize(document),
            { once: true }
        );
    } else {
        initialize(document);
    }

    /**
     * Shopify Theme Editor.
     */
    document.addEventListener(
        'shopify:section:load',
        (event) => {
            initialize(event.target);
        }
    );

    /**
     * Productos/cards cargados dinámicamente:
     * - Nosto
     * - infinite scroll
     * - predictive search
     * - section rendering
     */
    const observer =
        new MutationObserver(
            (mutations) => {
                mutations.forEach(
                    (mutation) => {
                        mutation.addedNodes.forEach(
                            (node) => {
                                if (
                                    !(node instanceof Element)
                                ) {
                                    return;
                                }

                                initialize(node);
                            }
                        );
                    }
                );
            }
        );

    observer.observe(
        document.body,
        {
            childList: true,
            subtree: true,
        }
    );

    /**
     * Si algún otro JS del theme pausa un video,
     * lo intentamos reproducir nuevamente cuando
     * vuelve a ser visible.
     */
    document.addEventListener(
        'visibilitychange',
        () => {
            if (!document.hidden) {
                playVideos(document);
            }
        }
    );
})();